import { Card, Flex, Spin } from 'antd';
import React from 'react';

import styles from './ListPage.module.scss';
import classNames from 'classnames';

function ListPage({ searchForm, actionBar, baseTable, loading = false, children, title, style, baseListPageListClassName, actionBarWrapperClassName, ...props }) {
    return (
        <Card className={styles.baseListPage} style={style}>
            <Spin spinning={loading}>
                <div className={classNames(styles.baseListPageList, baseListPageListClassName)}>
                    <div className={styles.title}>{title}</div>
                    <div className={actionBarWrapperClassName} style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                        {searchForm && <div style={{ width: '100%' }}>{searchForm}</div>}
                        <div className={classNames(props?.actionBarClassName)}>{actionBar}</div>
                    </div>
                    <div className={classNames(styles.actionBar, props?.actionBarClassName)}>{baseTable}</div>
                </div>
                <div>{children}</div>
            </Spin>
        </Card>
    );
}

export default ListPage;
